<form [formGroup]="form" (submit)="onSubmit()">

    <div class="row">
        <mat-form-field appearance="outline">
            <mat-label>Site da empresa</mat-label>
            <input type="text" matInput placeholder="Site da empresa" formControlName="site"/>
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field appearance="outline">
            <mat-label>Facebook</mat-label>
            <input type="text" matInput placeholder="Facebook" formControlName="facebook"/>
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field appearance="outline">
            <mat-label>Instagram</mat-label>
            <input type="text" matInput placeholder="Instagram" formControlName="instagram"/>
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field appearance="outline">
            <mat-label>Youtube</mat-label>
            <input type="text" matInput placeholder="Youtube" formControlName="youtube"/>
        </mat-form-field>
    </div>

    <div class="actions">
        <button mat-raised-button class="custom-primary" color="primary" type="submit" matStepperNext>Continuar</button>
    </div>

</form>
<iframe *ngIf="mauticFormSrc" [src]="mauticFormSrc" hidden frameborder="0" ></iframe>